import React, { Component } from 'react';

class MyjobSchedule extends Component {
    render() {
        return (
            <div>123</div>
        )
    }
}

export default MyjobSchedule
